import { SET_VIEWPORT, SHOW_ERROR, HIDE_ERROR } from "../actionTypes";
import { checkIsDesktop } from "../../util/viewport-utils";

export const initialState = {
  isDesktop: checkIsDesktop(),
  isShowedErrorMsg: false,
};

export function reducer(state, { type, payload }) {
  switch (type) {
    case SET_VIEWPORT:
      return { ...state, isDesktop: payload };

    case SHOW_ERROR: {
      return {
        ...state,
        isShowedErrorMsg: true,
      };
    }
    case HIDE_ERROR: {
      return {
        ...state,
        isShowedErrorMsg: false,
      };
    }

    default:
      return state;
  }
}
